import React from 'react';
import {useNavigate} from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';
import {Container, LogoWrapper, SwitcherWrapper} from './LogoWithLanguageSwitcher.styled';
import Manual from "./Manual";

interface LogoWithLanguageSwitcherProps {
    src: string;
    alt: string;
    clickable?: boolean;
}

const LogoWithLanguageSwitcher: React.FC<LogoWithLanguageSwitcherProps> = ({src, alt, clickable = false}) => {
    const navigate = useNavigate();

    const handleLogoClick = () => {
        if (clickable) {
            navigate('/login');
        }
    };

    return (
        <Container>
            <LogoWrapper clickable={clickable} onClick={handleLogoClick}>
                <img src={src} alt={alt}/>
            </LogoWrapper>
            <SwitcherWrapper>
                <LanguageSwitcher/>
                <Manual/>
            </SwitcherWrapper>
        </Container>
    );
};

export default LogoWithLanguageSwitcher;
